/*eslint-disable */
var $ = window.jQuery = jQuery = require('jquery');

import toast from '@/services/toast';

export default {
  name: 'categoryproject',
  components: {},
  props: [],
  data () {
    return {
      cousrsebyCategory: {}
    }
  },
  computed: {
     

    getCourseByCategory(){
      this.cousrsebyCategory = this.$store.getters.getCourseByCategory;   
   //   debugger;
      return this.cousrsebyCategory;
    },
    getCourseByCatgoryByActn(){
      let data = 
      this.$store.dispatch('CourseByCategoryAction',{id: this.$route.params.id}).then((response) => {
        if(response.data.code == '2000'){
          this.cousrsebyCategory = response.data.data
        }
      })
    }
  },
  mounted () { 
    this.getCourseByCategory
  },
  methods: {
    enrollcourse(id){
      let data= { course: id }
       this.$store.dispatch('setEnrollNewCourse', data)
       .then((res) => {
       //  console.log(res);
         if(res.data.code == '3017'){
           toast.success(res.data.msg);
         }
       })
       .catch((err) => {
        // console.log(err);
       })
     }
  }, 
  watch: {
    '$route.params.id': function (id) {
      
      if(id != undefined && id != ''){
        this.getCourseByCatgoryByActn;
    
      }
    },
    getCourseByCategory(){
      this.cousrsebyCategory = this.$store.getters.getCourseByCategory
      return this.cousrsebyCategory;
    }
  }
}
